import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import FooterLegal from "../../FooterLegal";
import { kanziSections } from "../../../../content/kanziSections";

const Footer = () => {
  const { footer } = kanziSections;

  return (
    <footer id="contact" className="site-footer">
      <div className="site-footer__noise" />
      <div className="site-footer__glow" />

      <div className="site-footer__inner">
        <SectionHeading
          title={footer.title}
          description={footer.description}
          centered
        />
        <Reveal>
          <div className="flex justify-center">
            <a
              href={`mailto:${footer.contactEmail}`}
              className="site-footer__email"
              title="Send an email to Data Chimp Labs"
            >
              {footer.contactEmail}
            </a>
          </div>
        </Reveal>

        <FooterLegal />
      </div>
    </footer>
  );
};

export default Footer;
